import Modal from "@/store/components/Modal";
import Button from "@/store/components/Button";
import ProductDetail from "@/store/components/ProductDetail";
import type { Coupon, Product } from "@/store/types";

interface ProductQuickViewProps {
  product: Product;
  isPurchased: boolean;
  isMember: boolean;
  coupons: Coupon[];
  busy: boolean;
  processingCode: string | null;
  onClose: () => void;
  onPurchase: (product: Product) => void;
  onAddToCart: (product: Product) => void;
}

/** Quick-view modal showing the full product detail; buying closes the modal first. */
export default function ProductQuickView({
  product,
  isPurchased,
  isMember,
  coupons,
  busy,
  processingCode,
  onClose,
  onPurchase,
  onAddToCart,
}: ProductQuickViewProps) {
  return (
    <Modal
      onClose={onClose}
      widthClassName="agd:max-w-[520px]"
      footer={
        <Button variant="ghost" onClick={onClose}>
          Close
        </Button>
      }
    >
      <ProductDetail
        product={product}
        isPurchased={isPurchased}
        isMember={isMember}
        coupons={coupons}
        busy={busy}
        processingCode={processingCode}
        compact
        onPurchase={(p) => {
          onClose();
          onPurchase(p);
        }}
        onAddToCart={(p) => {
          onClose();
          onAddToCart(p);
        }}
      />
    </Modal>
  );
}
